import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{backgroundColor: '#303030',
    color: '#ffffff',
    padding: '2rem',
    marginTop: '4rem',
    textAlign: 'center'}}>
      <div className="container">
        <p>© {currentYear} LetShop. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;